import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Visits: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Path
                d="M19.448 7.97c0-1.656-1.36-2.97-3.002-2.97-1.642 0-3.001 1.314-3.001 2.97v1.609h-.804C9.54 9.579 7 12.055 7 15.145v32.863C7 51.244 9.456 54 12.64 54h33.72c3.182 0 5.64-2.747 5.64-5.985v-32.87c0-3.09-2.54-5.566-5.64-5.566h-1.47v-1.61C44.89 6.314 43.53 5 41.887 5c-1.643 0-3.002 1.314-3.002 2.97v1.609H19.448v-1.61z"
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Path
                d="M12.64 52.895h33.725c2.565 0 4.641-2.043 4.641-4.566v-23.83H8v23.824c0 2.523 2.076 4.572 4.64 4.572z"
                fill="#fff"
                stroke={props.color}
            />
            <Path
                d="M17.79 29.263H13v4.856h4.79v-4.856zM17.79 36.236H13v4.855h4.79v-4.855zM17.79 43.209H13v4.855h4.79V43.21zM24.888 29.263h-4.79v4.856h4.79v-4.856zM24.888 36.236h-4.79v4.855h4.79v-4.855zM24.888 43.209h-4.79v4.855h4.79V43.21zM31.979 29.263h-4.79v4.856h4.79v-4.856zM31.979 36.236h-4.79v4.855h4.79v-4.855zM31.979 43.209h-4.79v4.855h4.79V43.21zM39.07 29.263h-4.79v4.856h4.79v-4.856zM39.07 36.236h-4.79v4.855h4.79v-4.855zM39.07 43.209h-4.79v4.855h4.79V43.21zM46.162 29.263h-4.79v4.856h4.79v-4.856zM46.162 36.236h-4.79v4.855h4.79v-4.855zM46.162 43.209h-4.79v4.855h4.79V43.21z"
                fill="#fff"
                stroke={props.color}
            />
            <Path
                d="M16.446 19.398c1.904 0 3.446-1.518 3.446-3.391s-1.542-3.391-3.446-3.391c-1.903 0-3.446 1.518-3.446 3.39 0 1.874 1.543 3.392 3.446 3.392z"
                stroke={props.color}
            />
            <Path
                d="M18.448 7.97c0-1.088-.896-1.97-2.001-1.97-1.106 0-2.002.882-2.002 1.97v7.052c0 1.088.896 1.97 2.002 1.97 1.105 0 2.001-.882 2.001-1.97V7.97z"
                fill="#fff"
                stroke={props.color}
            />
            <Path
                d="M41.888 19.398c1.903 0 3.446-1.518 3.446-3.391s-1.543-3.391-3.446-3.391c-1.904 0-3.447 1.518-3.447 3.39 0 1.874 1.543 3.392 3.447 3.392z"
                stroke={props.color}
            />
            <Path
                d="M43.89 7.97c0-1.088-.897-1.97-2.002-1.97-1.105 0-2.001.882-2.001 1.97v7.052c0 1.088.896 1.97 2.001 1.97s2.002-.882 2.002-1.97V7.97z"
                fill="#fff"
                stroke={props.color}
            />
        </Svg>
    );
};

export default React.memo(Visits);
